import React from 'react'
import styles from './CSS/Footer.module.css'

function Footer() {
    
    return (
        <div className="footer" id="footer"> 
        {/* <p>© 2023 starsearch</p> */}
        <p className={styles.attribution}>This product uses the TMDB API but is not endorsed or certified by <a href="https://www.themoviedb.org/?language=en-CA">TMDB</a> </p>
        </div>
    )
}

export default Footer